import {Component, EventEmitter, Output} from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { DomSanitizer } from '@angular/platform-browser';
import * as constants from '../../constants/app.constant';

import { SocketService } from '../../services/socket.service';
import { HttpService } from '../../services/http.service';
import { ToasterService } from '../../services/toaster.service';
import { CommonService } from '../../services/common.service';
@Component({
    template: `
    <div class="user-popover-outline">
        <div class="user-popover">
            <div class="bar-header">
                <h1 class="title ly_pop_title">채팅방 개설</h1>
                <a class="ly_pop_close" (click)="closePopover()"><mat-icon class="mat-icon-30 btn_close" svgIcon="xi-close"></mat-icon></a>
            </div>
            <form #createRoomForm="ngForm" >
                <div class="pop-body">
                    <div class="chatroom_set">
                        <ul>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 10px;">방제목</em>
                                    <div class="flex">
                                        <mat-form-field floatLabel="never">
                                            <input matInput type="text" name="roomname" [(ngModel)]="roomInfo.roomname" placeholder="방 제목을 입력하세요." required>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 14px;">참여등급</em>
                                    <div class="flex">
                                        <select style="width: 100%;" name="allowlevel" [(ngModel)]="roomInfo.allowlevel">
                                            <option value="">전체</option>
                                            <option value="2">이등병이상</option>
                                            <option value="6">하사이상</option>
                                            <option value="10">소위이상</option>
                                            <option value="13">소령이상</option>
                                            <option value="16">준장이상</option>
                                        </select>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 14px;">채팅방식</em>
                                    <div class="flex">
                                        <select style="width: 100%;" name="chatType" [(ngModel)]="roomInfo.chatType">
                                            <option value="N">일반</option>
                                            <option value="V">비디오</option>
                                            <option value="A">오디오</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="layout-row">
                                    <p class="desc">비디오와 오디오인 경우 해드셑을 착용해 주세요(하울링현상)</p>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 14px;">게임선택</em>
                                    <div class="flex">
                                        <select style="width: 100%;" name="gametype" [(ngModel)]="roomInfo.gametype">
                                            <option value="powerLadder">파워사다리</option>
                                            <option value="powerball">파워볼</option>
                                        </select>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 14px;">인원제한</em>
                                    <div class="flex">
                                        <select style="width: 100%;" name="allowmember" [(ngModel)]="roomInfo.allowmember">
                                            <option value="10">10명</option>
                                            <option value="100">100명</option>
                                            <option value="200">200명</option>
                                            <option value="300">300명</option>
                                            <option value="500">500명</option>
                                            <option value="1000">1000명</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="layout-row">
                                    <p class="desc">무료인 경우 참여자 1인당 100P 차감.</p>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 14px;">참여포인트</em>
                                    <div class="flex">
                                        <select style="width: 100%;" name="allowpoint" [(ngModel)]="roomInfo.allowpoint">
                                            <option value="0">무료</option>
                                            <option value="100">100P</option>
                                            <option value="200">200P</option>
                                            <option value="300">300P</option>
                                            <option value="400">400P</option>
                                            <option value="500">500P</option>
                                            <option value="600">600P</option>
                                            <option value="1000">1000P</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="layout-row">
                                    <p class="desc">무료로 선택할 경우 방장이 참여포인트 대납.</p>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 14px;">공개여부</em>
                                    <div class="flex">
                                        <select style="width: 100%;" name="openType" [(ngModel)]="roomInfo.openType"><!--  (change)="openTypeChanged()" -->
                                            <option value="O">공개</option>
                                            <option value="N">비공개</option>
                                            <option value="F">친구</option>
                                        </select>
                                    </div>
                                </div>
                            </li>
                            <li *ngIf="roomInfo.openType === 'N'">
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 10px;">패스워드</em>
                                    <div class="flex">
                                        <mat-form-field floatLabel="never">
                                            <input matInput type="text" name="openpassword" [(ngModel)]="roomInfo.openpassword" placeholder="비공개방의 비밀번호를 입력하세요.">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 10px;">메인사진</em>
                                    <div class="flex">
                                        <input type="file" ng2FileSelect [uploader]="uploader">

                                        <span [hidden]="!uploader.queue.length" *ngFor="let item of uploader.queue">
                                            <img [src]="item.filePreviewPath">
                                        </span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="layout-row">
                                    <em style="width: 80px;margin-top: 14px;">채팅개설권</em>
                                    <div class="flex" *ngIf="chat_items.length">
                                        <select style="width: 100%;" name="use_item" [(ngModel)]="roomInfo.use_item">
                                            <option *ngFor="let v of chat_items" value="{{v.item_id}}">{{v.item_name}}({{v.item_count}})</option>
                                        </select>
                                    </div>
                                    <div class="flex" *ngIf="!chat_items.length">
                                        <a class="mat-raised small mat-button mat-ink-ripple" (click)="gotoMarket()"><span>개설권 구매</span></a><!-- ui-sref="market.items" -->
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="pop-footer">
                    <button mat-button class="full btn_create" [disabled]="!createRoomForm.form.valid || !roomInfo.use_item" (click)="createRoom()"><span style="color: #fff;">개설하기</span></button>
                </div>
            </form>
        </div>
    </div>
    <!-- // 목표설정 -->`,
    styleUrls: ['style.scss']
})



export class LayerPopChatRoomSetComponent {
   //  private navCtrl: NavController;
    @Output() popclosed = new EventEmitter();

    roomInfo: any = {allowpoint: '0', allowlevel: '', openType: 'O', chatType: 'N', allowmember: '10', gametype: 'powerLadder'};
    chat_items = [];

    uploader: FileUploader;
    imageUploaded = false;

    constructor(
        private socketService: SocketService,
        private http: HttpService,
        protected toasterService: ToasterService,
        private commonService: CommonService,
        private sanitizer: DomSanitizer) { // private navParams:
        // this.navCtrl = app.getActiveNav();
        this.roomInfo.prefix = commonService.guid(); // 파일업로드시 이부분을 붙혀서 서버에 올리고 게시물 작성시에도 이 부분이 있으면 현재 게시물에 대한 첨부로 인식하여 이후단을 처리한다.
        this.get_chat_items();

        // uploader 정의
        this.uploader = new FileUploader({url: constants.API_URL + 'upload?token=' + localStorage.getItem('authToken') + '&prefix=' + this.roomInfo.prefix});
        // 파일업로드후 현재 로컬경로 반환
        this.uploader.onAfterAddingFile = (fileItem: any) => {
            fileItem.withCredentials = false; // preflight error occur
            fileItem.filePreviewPath  = this.sanitizer.bypassSecurityTrustUrl((window.URL.createObjectURL(fileItem._file)));
            if (this.uploader.queue.length > 1) {
                this.uploader.queue.splice(0, 1);
            }
            // if (this.uploader.getNotUploadedItems().length > 1)
            //    this.uploader.removeFromQueue(0);
        };
        // CALLBACKS
        this.uploader.onCompleteAll = () => {
            this.imageUploaded = true;
        };
    }


    closePopover() {
        this.popclosed.emit();
    }

    // 사용가능한 채팅방 개설권이 있는 있는지 확인
    private get_chat_items() {
        this.http.get({url: 'mypage/mitems', params: {items: '4,5,6'}}).then((obj) => {
            this.chat_items = obj.items;
        });
    }

    createRoom() {
        this.roomInfo.roomid = this.commonService.guid();
        const queue = [];
        if (this.uploader.queue.length > 0 && this.imageUploaded === false) {
            // 먼저 이미지를 업로드후 이 부분을 처리한다.
            // 로컬테스트시 보안문제로 업로드 되지 않는다.
            this.uploader.uploadAll();
            return;
        }

        // 업로된 파일정보를 올린다.
        if (this.uploader.queue.length > 0 ) {
            for (let i = 0; i < this.uploader.queue.length; i++ ) {
                queue.push(this.uploader.queue[i].file.name);
            }
        }

        const preParams = {use_item: this.roomInfo.use_item, gametype: this.roomInfo.gametype, roomid: this.roomInfo.roomid, queue: queue.join('|')};

        this.http.post({url: 'chat/create-chat-room', params: preParams}).then((obj) => {
            if (obj.result) { // 소켓에 전송한다.
                this.roomInfo.info    = obj.data;
                this.socketService.Emit('add_room', this.roomInfo);
                this.closePopover();
            } else {
                this.toasterService.showToaster('error', obj.message);
            }
        });
    }

    gotoMarket() {
        // ui-sref='market.items' not work properbly
        // this.navCtrl.push('market');
        this.closePopover();
    }

    // 이미지를 원상태로 복구한다(기존 queue에 있던 것을 삭제한다.)
    clearQueue() {
        if (this.uploader.queue.length > 0) {
            this.uploader.clearQueue();
        }
    }
}
